// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__zswRs","header":"style__header__iF0xv","headerText":"style__headerText__KrdKW","content":"style__content__cQGfx"};